
var ListingFilterMixin = {
	props : [
		'filter'
	],

	created : function(){

		for (let input of Object.values(this.filter.inputs)){

			this.$data[input.name] = '';

			if (input.type === 'selectmultiple') {
				this.$data[input.name] = {};
			}

			if (this.filter.data !== null) {

				if (this.filter.data[input.name] !== undefined) {
					this.$data[input.name] = this.filter.data[input.name];
					continue;
				}
				if (this.filter.data['subChoices'] !== undefined) {
					this.$data['subChoices'] = this.filter.data['subChoices'];
				}
				if (this.filter.data['choice'] !== undefined) {
					this.$data['choice'] = this.filter.data['choice'];
				}
			}

            if (input.options !== undefined){

                this.$data[input.name] = [];

                let defaultOpt = Object.values(input.options).filter(opt => opt.default)

                if(defaultOpt.length){
                    this.$data[input.name] = defaultOpt[0].value;
                }else{
                    if (input.type === 'select' || input.type === 'radio') {
                        if (typeof input.options == 'object') {
                            this.$data[input.name] = input.options[Object.keys(input.options)[0]]?.value;
                        } else {
                            this.$data[input.name] = input.options[0]?.value;
                        }
                    }
                }

			}
		}
	},

	watch : {
		data(newVal, oldVal){
			this.$emit('filter:update', newVal);
		}
	}
}


export default ListingFilterMixin;
